import { v4 as uuid } from "uuid";
import { makeObservable, observable } from "mobx";
import { IEntityType } from "../types/entities";

export class Type implements IEntityType {
  constructor(entityType: IEntityType) {
    makeObservable(this);

    Object.assign(this, entityType);
  }

  @observable
  id: string = uuid();

  @observable
  name: string = "";
}
